export const originalGrid = {
  layout_cards: {
    lg: [
      {
        i: "card_1",
        x: 0,
        y: 0,
        w: 1,
        h: 1.3,
        content: "Total Users",
        section_key: "layout_cards",
      },
      {
        i: "card_2",
        x: 1,
        y: 0,
        w: 1,
        h: 1.3,
        content: "Total Active Users",
        section_key: "layout_cards",
      },
      {
        i: "card_3",
        x: 2,
        y: 0,
        w: 1,
        h: 1.3,
        content: "  ",
        section_key: "layout_cards",
      },
    ],
    md: [
      {
        i: "card_1",
        x: 0,
        y: 0,
        w: 1,
        h: 1.3,
        content: "Total Users",
        section_key: "layout_cards",
      },
      {
        i: "card_2",
        x: 1,
        y: 0,
        w: 1,
        h: 1.3,
        content: "Total Active Users",
        section_key: "layout_cards",
      },
      {
        i: "card_3",
        x: 2,
        y: 0,
        w: 1,
        h: 1.3,
        content: "Total Roles",
        section_key: "layout_cards",
      },
    ],
    sm: [
      {
        i: "card_1",
        x: 0,
        y: 0,
        w: 1,
        h: 1.3,
        content: "Total Users",
        section_key: "layout_cards",
      },
      {
        i: "card_2",
        x: 0,
        y: 0,
        w: 1,
        h: 1.3,
        content: "Total Active Users",
        section_key: "layout_cards",
      },
      {
        i: "card_3",
        x: 0,
        y: 0,
        w: 1,
        h: 1.3,
        content: "Total Roles",
        section_key: "layout_cards",
      },
    ],
  },
  layout_charts: {
    lg: [
      {
        i: "dongnut_1",
        x: 0,
        y: 0,
        w: 1,
        h: 2.5,
        content: "User Status Distribution",
        section_key: "layout_charts",
      },
      {
        i: "dongnut_2",
        x: 1,
        y: 0,
        w: 2,
        h: 2.5,
        content: "Role Distribution",
        section_key: "layout_charts",
      },
    ],
    md: [
      {
        i: "dongnut_1",
        x: 0,
        y: 0,
        w: 1,
        h: 2.5,
        content: "User Status Distribution",
        section_key: "layout_charts",
      },
      {
        i: "dongnut_2",
        x: 1,
        y: 0,
        w: 2,
        h: 2.5,
        content: "Role Distribution",
        section_key: "layout_charts",
      },
    ],
    sm: [
      {
        i: "dongnut_1",
        x: 0,
        y: 0,
        w: 1,
        h: 2.5,
        content: "User Status Distribution",
        section_key: "layout_charts",
      },
      {
        i: "dongnut_2",
        x: 0,
        y: 1,
        w: 1,
        h: 2.5,
        content: "Role Distribution",
        section_key: "layout_charts",
      },
    ],
  },
  layout_col1: {
    lg: [
      {
        i: "cards_row",
        x: 0,
        y: 0,
        w: 3,
        h: 1.5,
        content: "cards_row",
        section_key: "layout_col1",
      },
      {
        i: "cards_row_dongnut",
        x: 0,
        y: 1,
        w: 3,
        h: 3.5,
        content: "cards_row_dongnut",
        section_key: "layout_col1",
      },
    ],
    md: [
      {
        i: "cards_row",
        x: 0,
        y: 0,
        w: 3,
        h: 1.5,
        content: "cards_row",
        section_key: "layout_col1",
      },
      {
        i: "cards_row_dongnut",
        x: 0,
        y: 1,
        w: 3,
        h: 3.5,
        content: "cards_row_dongnut",
        section_key: "layout_col1",
      },
    ],
    sm: [
      {
        i: "cards_row",
        x: 0,
        y: 0,
        w: 1,
        h: 4,
        content: "cards_row",
        section_key: "layout_col1",
      },
      {
        i: "cards_row_dongnut",
        x: 0,
        y: 1,
        w: 1,
        h: 5.1,
        content: "cards_row_dongnut",
        section_key: "layout_col1",
      },
    ],
  },
  layout_col2: {
    lg: [
      {
        i: "activity",
        x: 0,
        y: 0,
        w: 3,
        h: 3,
        content: "Activities",
        section_key: "layout_col2",
      },
      {
        i: "pinned_items",
        x: 0,
        y: 0,
        w: 3,
        h: 2,
        content: "Pined Items",
        section_key: "layout_col2",
      },
    ],
    md: [
      {
        i: "activity",
        x: 0,
        y: 0,
        w: 3,
        h: 3,
        content: "Activities",
        section_key: "layout_col2",
      },
      {
        i: "pinned_items",
        x: 0,
        y: 0,
        w: 3,
        h: 2,
        content: "Pined Items",
        section_key: "layout_col2",
      },
    ],
    sm: [
      {
        i: "activity",
        x: 0,
        y: 0,
        w: 1,
        h: 3,
        content: "Activities",
        section_key: "layout_col2",
      },
      {
        i: "pinned_items",
        x: 0,
        y: 0,
        w: 1,
        h: 2,
        content: "Pined Items",
        section_key: "layout_col2",
      },
    ],
  },
  layout_cols: {
    lg: [
      {
        i: "column_1",
        x: 1,
        y: 0,
        w: 2.1,
        h: 5.2,
        content: "column1",
        section_key: "layout_cols",
      },
      {
        i: "column_2",
        x: 12,
        y: 0,
        w: 0.9,
        h: 5.2,
        content: "column2",
        section_key: "layout_cols",
      },
    ],
    md: [
      {
        i: "column_1",
        x: 1,
        y: 0,
        w: 8.5,
        h: 10,
        content: "column1",
        section_key: "layout_cols",
      },
      {
        i: "column_2",
        x: 12,
        y: 0,
        w: 3.5,
        h: 5,
        content: "column2",
        section_key: "layout_cols",
      },
    ],
    sm: [
      {
        i: "column_1",
        x: 0,
        y: 0,
        w: 1,
        h: 9.2,
        content: "column1",
        section_key: "layout_cols",
      },
      {
        i: "column_2",
        x: 0,
        y: 0.2,
        w: 1,
        h: 5,
        content: "column2",
        section_key: "layout_cols",
      },
    ],
  },
  layout : {
    lg: [
      { content: "Total Files", i: 'card: Total Files', x: 0, y: 0, w: 1, h: 1 },
      { content: "Total File Size", i: 'card1: Total File Size', x: 1, y: 0, w: 1, h: 1 },
      { content: "File With Location", i: 'card2: File With Location', x: 2, y: 0, w: 1, h: 1 },
      { content: "File Storage", i: 'donut: File Storage', x: 3, y: 0, w: 3, h: 1.5 },
      { content: "Recent Files", i: 'table: Recent Files', x: 4, y: 0, w: 3, h: 1.6 },
    ]
  }
};
